<template>
  <div class="wrapper form-control p-0 input-group">
    <vue-autosuggest
      :suggestions="visibleSuggestions"
      v-model="currentValue"
      :input-props="{
        class: 'form-control border-0 h-100',
        id: identifier,
        name: identifier,
        placeholder,
      }"
      :getSuggestionValue="getSuggestionValue"
      @input="inputHandler"
      @selected="selectHandler"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
      class="flex-grow-1"
    >
      <template slot-scope="{ suggestion }">
        {{ getSuggestionValue(suggestion) }}
      </template>
    </vue-autosuggest>
    <div class="input-group-append">
      <button class="btn btn-secondary-link" type="button">
        <SearchIcon class="svg-24 svg-fill-dark" />
      </button>
    </div>
  </div>
</template>

<script>
import { VueAutosuggest } from "vue-autosuggest";
import SearchIcon from "../../icons/atalanda/search.svg";

export default {
  name: "Autocomplete",
  components: {
    VueAutosuggest,
    SearchIcon,
  },
  props: {
    placeholder: {
      type: String,
      required: true,
    },
    initialValue: {
      type: String,
      default: "",
      required: false,
    },
    identifier: {
      type: String,
      required: true,
    },
    suggestions: {
      type: Array,
      required: true,
    },
    getSuggestionValue: {
      type: Function,
      required: false,
      default: suggestion => suggestion.item,
    },
    filteredSuggestions: {
      type: Array,
      required: false,
      default: () => undefined,
    },
  },
  data() {
    return {
      currentValue: this.initialValue,
    };
  },
  computed: {
    visibleSuggestions() {
      return (
        this.filteredSuggestions || [
          {
            data: this.suggestions.filter(suggestion => {
              return suggestion.toLowerCase().includes(this.currentValue.toLowerCase());
            }),
          },
        ]
      );
    },
  },
  watch: {
    initialValue(value) {
      this.currentValue = value;
    },
  },
  methods: {
    inputHandler(value) {
      this.$emit("input", value);
    },
    selectHandler(suggestion) {
      this.$emit("select", suggestion);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.wrapper:focus-within {
  border: $width-border-thin solid $gray-400;
}
</style>
